export default __webpack_public_path__ + "static/media/adventurechina.2faa21cc.jpg";